import { Avatar, Box, Typography } from "@mui/material";
import type { ReactNode } from "react";
import { getInitials } from "../../functions/udfHelper";
import shiPalette from "../../theme/shiPalette";

interface DrawerReadOnlyFieldProps {
  label: ReactNode;
  value: readonly string[] | null | undefined;
}

export function DrawerReadOnlyField({
  label,
  value,
}: Readonly<DrawerReadOnlyFieldProps>) {
  const contactNames = value ?? [];

  return (
    <Box>
      <Typography variant="caption" color="textSecondary">
        {label}
      </Typography>
      {contactNames.length > 0 ? (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          {contactNames.map((contact, index) => (
            <Box
              key={`${contact}-${index}`}
              sx={{ display: "flex", alignItems: "center", gap: 1 }}
            >
              <Avatar
                sx={{
                  width: 28,
                  height: 28,
                  fontSize: 12,
                  flexShrink: 0,
                  bgcolor: shiPalette.info.light,
                  color: shiPalette.text.primary,
                }}
              >
                {getInitials(contact)}
              </Avatar>
              <Typography variant="body2" noWrap>
                {contact}
              </Typography>
            </Box>
          ))}
        </Box>
      ) : (
        <Typography variant="body2">--</Typography>
      )}
    </Box>
  );
}
